import type { Level, LevelFile } from './engine/level';
import { PlayScreen } from './game/play';
import { isUnlocked, loadProgress, markCleared, saveProgress } from './game/progress';
import { renderSelect } from './game/select';

const app = document.getElementById('app')!;
let levels: Level[] = []; let byId = new Map<string, Level>(); let current: { destroy(): void } | null = null;
const FIRST = 'beginner-1';

function nextOf(l: Level): Level | undefined {
  const same = levels.filter((x) => x.pack === l.pack).sort((a, b) => a.n - b.n);
  const i = same.findIndex((x) => x.id === l.id);
  return i >= 0 ? same[i + 1] : undefined;
}
function render() {
  current?.destroy(); current = null;
  const m = /^#\/?play\/([\w-]+)/.exec(location.hash);
  if (m) {
    const level = byId.get(m[1]!);
    if (!level || !isUnlocked(loadProgress(), level, levels)) { location.hash = ''; return; }
    saveProgress({ ...loadProgress(), last: level.id });
    current = new PlayScreen(app, level, {
      onCleared: (l, moves, stars) => saveProgress(markCleared(loadProgress(), l.id, moves, stars)),
      onBack: () => { location.hash = ''; },
      onNext: (l) => { const n = nextOf(l); if (n) location.hash = `play/${n.id}`; },
      hasNext: (l) => !!nextOf(l),
      best: (l) => loadProgress().levels[l.id]?.best,
    });
    return;
  }
  current = renderSelect(app, levels, loadProgress(), (l) => { location.hash = `play/${l.id}`; });
}
function handleReset() {
  const q = new URLSearchParams(location.search);
  if (q.get('stage') !== 'reset') return;
  saveProgress({ levels: {}, last: FIRST }); q.delete('stage');
  const qs = q.toString(); history.replaceState(null, '', `${location.pathname}${qs ? '?' + qs : ''}#play/${FIRST}`);
}
async function boot() {
  handleReset();
  const file = (await (await fetch('/levels.json', { cache: 'no-cache' })).json()) as LevelFile;
  levels = file.levels; byId = new Map(levels.map((l) => [l.id, l]));
  window.addEventListener('hashchange', render); render();
}
boot().catch((e) => { app.textContent = `불러오기 실패: ${e}`; });
